<template>
  <ValidationProvider :name="name" :rules="rules">
    <b-form-group
      class="h-form-group"
      :label="$attrs.label"
      :label-for="nameToSnakeCase"
    >
      <b-input-group :prepend="`${prepend}`" :append="`${append}`">
        <vue-tel-input
          class="phone-input-field"
          v-bind="$attrs"
          v-if="type === 'phone'"
          :id="nameToSnakeCase"
          :name="name"
          @input="e => phoneHandler(e)"
          defaultCountry="US"
          :autoDefaultCountry=false
          :only-countries="['US','CA','MX']"
          @country-changed="countryChanged"
          mode="national"
        />
        <b-form-datepicker
          class="date-input-field"
          v-bind="$attrs"
          v-else-if="type === 'date'"
          :id="nameToSnakeCase"
          :name="name"
          @input="e => $emit('input', e)"
        />
      <b-form-input
          class="standard-input-field"
          v-else
          v-bind="$attrs"
          :id="nameToSnakeCase"
          :name="name"
          @input="e => $emit('input', e)"
        />
      </b-input-group>
    </b-form-group>
    <div class="text-danger field-errors">
      <span v-for="err in $attrs.errors[name]" :key="err">
        {{ capitalizedError(err) }}
      </span>
    </div>
  </ValidationProvider>
</template>

<script>
export default {
  data() {
    return {
      countryCode: ''
    }
  },
  props: {
    name: String,
    rules: String,
    type: {
      type: String,
      default: 'text'
    },
    prepend: {
      type: String,
      default: ''
    },
    append: {
      type: String,
      default: ''
    }
  },
  methods: {
    capitalizedError(error) {
      if (error) {
        return error.charAt(0).toUpperCase() + error.slice(1);
      }
    },
    countryChanged(country) {
      this.countryCode = '+' + country.dialCode + ' '
    },
    phoneHandler(e) {
      if (e.length === 14) {
        this.$emit('input', this.countryCode + e)
      }
    }
  },
  computed: {
    nameToSnakeCase() {
      return this.name.replace(/\s/g, '_').toLowerCase()
    }
  }
}
</script>

<style src="vue-tel-input/dist/vue-tel-input.css"></style>

<style lang="scss" scoped>
.btn-group-vertical > button {
  margin-bottom: 10px;
  border-radius: 5px !important;
}
.vue-tel-input {
  width: 100%;
}
</style>